import { get } from 'lodash-es'

const getInitialState = (isQuestionsEnabledDefault = false) => ({
  unreadQuestionsIdList: new Set(),
  isSecondaryPanelVisible: false,
  secondaryPanelContentType: null,
  isQuestionsEnabled: isQuestionsEnabledDefault,
  isShowingSpeakers: true,
})

export default ({ actionNames, isQuestionsEnabledDefault }) => {
  const initialState = getInitialState(isQuestionsEnabledDefault)

  return (state = initialState, action = undefined) => {
    switch (action.type) {
      case actionNames.INIT: {
        return {
          ...state,
          selectedSidebarTab: action.defaultSidebarTab,
        }
      }
      case actionNames.FETCH_LIVE_DATA_SUCCESS: {
        return {
          ...state,
          isQuestionsEnabled: get(action, 'liveData.question_mode') === 'ask',
        }
      }
      case actionNames.REALTIME_QUESTION_ADDED: {
        return {
          ...state,
          unreadQuestionsIdList: new Set([
            ...state.unreadQuestionsIdList,
            action.commentId,
          ]),
        }
      }
      case actionNames.TOGGLE_SECONDARY_PANEL: {
        const isSecondaryPanelVisible = !state.isSecondaryPanelVisible
        let { unreadQuestionsIdList } = state

        if (action.payload[0] === 'questions' && !isSecondaryPanelVisible) {
          unreadQuestionsIdList = new Set()
        }

        return {
          ...state,
          isSecondaryPanelVisible,
          secondaryPanelContentType: action.payload[0] || null,
          unreadQuestionsIdList,
        }
      }
      case actionNames.TOGGLE_QUESTIONS_MODE: {
        return {
          ...state,
          isQuestionsEnabled: !state.isQuestionsEnabled,
        }
      }
      /**
       * Since this is a sub feature that is dispatching this action, we have to
       *  hardcode it since we can't get to it otherwise.
       */
      case 'INFO-PANEL-SPEAKERS:FETCH_SUCCESS': {
        const { speakers } = action

        return {
          ...state,
          isShowingSpeakers: !!speakers?.length,
        }
      }
      default:
        return state
    }
  }
}
